var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import axios from "axios";
import { BAlert, BButton, BCard, BCardBody, BCardFooter, BEmbed, BForm, BFormCheckbox, BFormGroup, } from "bootstrap-vue";
import { ref } from "vue";
import { useRouter } from "vue-router/composables";
import { withPrefix } from "@/utils/redirect";
import { errorMessageAsString } from "@/utils/simple-error";
export default /*#__PURE__*/ _defineComponent({
    __name: 'NewUserConfirmation',
    props: {
        termsUrl: null,
        registrationWarningMessage: null
    },
    emits: ["setRedirect"],
    setup(__props, { emit }) {
        const router = useRouter();
        const urlParams = new URLSearchParams(window.location.search);
        const messageText = ref("");
        const termsRead = ref(false);
        const messageVariant = ref("");
        const provider = ref(urlParams.get("provider"));
        const token = ref(urlParams.get("provider_token"));
        function login() {
            // set url to redirect user to 3rd party management after login
            emit("setRedirect", "/user/external_ids");
            router.push("/login");
        }
        function submit() {
            return __awaiter(this, void 0, void 0, function* () {
                if (!provider.value || !token.value) {
                    messageVariant.value = "danger";
                    messageText.value = "Missing provider and/or token.";
                }
                else {
                    try {
                        const response = yield axios.post(withPrefix(`/authnz/${provider.value}/create_user?token=${token.value}`));
                        if (response.data.redirect_uri) {
                            router.push(response.data.redirect_uri);
                        }
                        else {
                            router.push("/");
                        }
                    }
                    catch (error) {
                        messageVariant.value = "danger";
                        messageText.value = errorMessageAsString(error, "Login failed for an unknown reason.");
                    }
                }
            });
        }
        return { __sfc: true, emit, router, urlParams, messageText, termsRead, messageVariant, provider, token, login, submit, BAlert, BButton, BCard, BCardBody, BCardFooter, BEmbed, BForm, BFormCheckbox, BFormGroup, withPrefix };
    }
});
